import { Modal } from "./ui/Modal";
import { useUiStore } from "../stores/uiStore";

const rows = [
  ["⌘ N", "新規タスク"],
  ["⌘ F", "検索"],
  ["⌘ 1〜5", "フィルタ切替"],
  ["⌘ R", "今すぐ同期"],
  ["⌘ ,", "設定"],
  ["⌘ Z", "削除を元に戻す"],
  ["?", "ショートカット一覧"],
  ["Esc", "閉じる"],
];

export function ShortcutHintOverlay() {
  const open = useUiStore((s) => s.shortcutsOpen);
  const setOpen = useUiStore((s) => s.setShortcutsOpen);
  return (
    <Modal open={open} className="max-w-[520px]">
      <div className="p-5">
        <h2 className="mb-4 text-lg font-semibold">ショートカット</h2>
        <div className="grid gap-2">
          {rows.map(([key, label]) => (
            <div key={key} className="flex items-center justify-between rounded-md border border-border px-3 py-2 text-sm dark:border-border-dark">
              <span className="text-muted dark:text-muted-dark">{label}</span>
              <kbd className="font-mono text-xs font-semibold">{key}</kbd>
            </div>
          ))}
        </div>
        <button className="mt-4 text-sm text-muted hover:text-text dark:text-muted-dark" onClick={() => setOpen(false)}>閉じる</button>
      </div>
    </Modal>
  );
}
